/**
 * Same-tab slide sync: `storage` only fires across windows, so presenter/audience/console
 * also listen for this event whenever `current-slide-state` is written.
 */
export const DECKPACK_CURRENT_SLIDE_EVENT = 'deckpack-current-slide-state';

export function broadcastCurrentSlideState(state) {
  if (typeof window === 'undefined' || !state) return;
  try {
    window.dispatchEvent(new CustomEvent(DECKPACK_CURRENT_SLIDE_EVENT, { detail: state }));
  } catch {
    /* ignore */
  }
}
